'use memo'

import {
  buildOfficialTypeNameLookup,
  buildTeamHistory,
  buildTeamHistoryCopy,
  getTeamHistoryTerms,
  type TeamHistoryCopy,
  type TeamHistoryFields,
  type TeamHistoryView,
} from '@sportninja/common/features/registration/teamHistory'
import { useTeamOfficialTypes } from '@sportninja/common/hooks/useTeamOfficialTypes'

export interface TeamHistoryTools {
  /** `null` when the team carries no history (the player endpoint's shape). */
  buildHistory: (team: TeamHistoryFields) => TeamHistoryView | null
  copy: TeamHistoryCopy
}

/**
 * Everything the team picker needs to render history for its teams: a builder
 * (official role names resolved from the registration sport's role list) and
 * the tenant-worded copy. Until the roles load, officials render without one.
 */
export const useTeamHistory = (
  sportId: string | null | undefined
): TeamHistoryTools => {
  'use memo'

  const { teamOfficialTypes } = useTeamOfficialTypes(sportId)
  const terms = getTeamHistoryTerms()
  const officialTypeName = buildOfficialTypeNameLookup(teamOfficialTypes)

  return {
    buildHistory: (team) => buildTeamHistory(team, { terms, officialTypeName }),
    copy: buildTeamHistoryCopy(terms),
  }
}
